import React from 'react';
import { Badge } from 'react-bootstrap';

export const STATUS_COLORS = {
  received: 'secondary',
  processing: 'info',
  completed: 'success',
  failed: 'danger',
};

export const ErrorBadge = ({ children, className }) => (
  <Badge bg="danger" text="white" className={className}>
    {children}
  </Badge>
);

export const StatusBadge = ({ status, className, style }) => {
  const bg = STATUS_COLORS[status] || 'secondary';
  const text = status === 'failed' ? 'white' : undefined;

  return (
    <Badge bg={bg} text={text} className={className} style={style}>
      {status}
    </Badge>
  );
};

const API_VERSION_COLORS = {
  v1: 'info',
  v2: 'secondary',
  v3: 'primary',
};

export const resolveTaskApiVersion = (task) => {
  if (!task || typeof task !== 'object') {
    return 'v1';
  }
  // Prefer the version explicitly reported by the API (e.g. attributes.api_version = 'v1').
  const explicit = task.api_version || task.attributes?.api_version;
  if (typeof explicit === 'string' && /^v\d+$/i.test(explicit.trim())) {
    return explicit.trim().toLowerCase();
  }
  if (task.attributes?.recognition_mode === 'client_payload') {
    return 'v3';
  }
  return 'v1';
};

export const ApiVersionBadge = ({ task, className }) => {
  const version = resolveTaskApiVersion(task);
  const bg = API_VERSION_COLORS[version] || 'secondary';

  return (
    <Badge
      bg={bg}
      text={bg === 'secondary' ? undefined : 'white'}
      className={className}
    >
      {version.toUpperCase()}
    </Badge>
  );
};

// endpoint -> react-bootstrap Badge props. Falls back to a neutral gray badge for
// unknown/legacy endpoint values (e.g. 'recognize') so nothing breaks if new endpoints
// are added server-side before the dashboard is updated.
const ENDPOINT_BADGE_STYLES = {
  recognize: { bg: '#6c757d', color: '#fff' },
  recognize_backup: { bg: '#1f4e63', color: '#8fd7ff' },
  estimate_price: { bg: '#3b2a5e', color: '#c9a8ff' },
};

export const EndpointBadge = ({ endpoint, className }) => {
  const style = ENDPOINT_BADGE_STYLES[endpoint] || { bg: '#6c757d', color: '#fff' };

  return (
    <Badge
      className={className}
      style={{ backgroundColor: style.bg, color: style.color }}
    >
      {endpoint || 'unknown'}
    </Badge>
  );
};

// True when a task's stored_result was produced by the OpenAI backup path
// (recognize-backup / estimate-price) instead of the primary vendor.
export const isAiEstimatedResult = (response) => Boolean(
  response && typeof response === 'object' && response.raw_identify_result
);

export const AiEstimatedBadge = ({ className, children }) => (
  <Badge
    className={className}
    style={{ backgroundColor: '#3b2a5e', color: '#c9a8ff' }}
  >
    {children || 'AI Estimated'}
  </Badge>
);
